/* eslint no-underscore-dangle: [error, { allow: [_id] }] */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import NewMatch from '../../components/matches/NewMatch';

class NewMatchContainer extends Component {
  state = {
    newMatchRoot: false,
  };

  componentDidMount() {
    const newMatchRoot = document.getElementById('matches-new-match');
    if (newMatchRoot) {
      ReactDOM.render(<NewMatch />, newMatchRoot);
    }

    this.setState({ newMatchRoot });
  }

  componentWillUnmount() {
    const { newMatchRoot } = this.state;
    if (newMatchRoot) {
      ReactDOM.unmountComponentAtNode(newMatchRoot);
    }
  }

  render() {
    const { newMatchRoot } = this.state;
    if (newMatchRoot) {
      return (null);
    }

    return (
      <NewMatch />
    );
  }
}

export default NewMatchContainer;
